import { forwardRef } from "react";

const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL;

export const Radio = forwardRef(
  ({ checked, onChange, size, style, className, id }, ref) => {
    return (
      <>
        <input
          type="radio"
          id={id}
          checked={checked}
          onChange={onChange}
          className="sr-only"
          ref={ref}
        />
        {checked ? (
          <img
            onClick={onChange}
            src={`${S3_BASE_URL}/assets/icons/radio_a.svg`}
            alt="Selected radio button"
            style={{
              height: size ? size : 15,
              width: size ? size : 15,
              ...style,
            }}
            className={className}
          />
        ) : (
          <img
            onClick={onChange}
            src={`${S3_BASE_URL}/assets/icons/radio_d.svg`}
            alt="Unselected radio button"
            style={{
              height: size ? size : 15,
              width: size ? size : 15,
              ...style,
            }}
            className={className}
          />
        )}
      </>
    );
  }
);

Radio.displayName = "Radio";

export default Radio;
